import { Injectable, WritableSignal, signal } from '@angular/core';
import html2canvas from 'html2canvas';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CaptureScreenService {
  generatedImage: WritableSignal<string> = signal<string>('');

  private readonly generatedImageSubject = new Subject<string>();
  generatedImage$: Observable<string> =
    this.generatedImageSubject.asObservable();

  captureScreen(itemId: string): void {
    void this.captureWithPromise(itemId);
  }

  captureWithPromise(itemId: string, _showSpinner?: boolean | HTMLElement): Promise<string> {
    const target =
      (_showSpinner instanceof HTMLElement ? _showSpinner : null) ??
      (document.querySelector(`#${itemId}`) as HTMLElement);

    if (!target) {
      return Promise.resolve('');
    }

    return html2canvas(target, {
      backgroundColor: '#ffffff',
      scale: 2,
      useCORS: true,
      logging: false,
      width: target.scrollWidth,
      height: target.scrollHeight,
    }).then((canvas) => {
      const imagenBase64 = canvas.toDataURL('image/jpeg', 0.92);
      if (imagenBase64.length) {
        this.generatedImage.set(imagenBase64);
        this.generatedImageSubject.next(imagenBase64);
      }
      return imagenBase64;
    });
  }
}
